// G-funk, West Coast style: a slow, swung beat, a fat bass that walks up to
// each chord, an electric piano wavering through a tremolo on jazzy chords,
// and a high whistle lead whining over the top. An original piece in the style
// of the nineties; the swing makes every second sixteenth late.
meter: 4/4
tempo: 92
key: D minor
swing 58%

drums: drums.808
drums {
  bd   = b --b- b -
  sd   = - s - s
  clap = - p - p
  hh   = cccc cccc cccc ccco
}

bass: poly.moog_bass -> lowpass
bass = | d2 _ [- d2] [f2 a2] | g1 _ [- g1] [bb1 d2] |
       | bb1 _ [- bb1] [d2 f2] | a1 _ [- a1] [c#2 e2] |
bass.lowpass.cutoff = 700 Hz

keys: keys.epiano -> tremolo -> chorus -> reverb
keys { chords = | Dm9 | Gm9 | Bbmaj7 | A7(b9) | }
keys.tremolo.rate = 4
keys.volume = 0.6
keys.reverb.mix = 0.3

lead: poly.whistle_lead -> delay -> reverb
lead = | - - a5 _ | [g5 f5] e5 _ d5 | - - bb5 _ | [a5 g5] f5 _ e5 |
lead.volume = 0.4
lead.delay.sync = 0.75
lead.delay.mix = 0.3
lead.reverb.mix = 0.4
